const digest = '63f2229b0b1717b2d8a39671c895bb58958dea6d839d4ea62f7d894f096f0d10';
const css = `._card_1gbmn_1 a { 
    text-decoration: underline;
}; `;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'card': '_card_1gbmn_1' };
export const card = '_card_1gbmn_1';
export { css, digest };